module.exports = __webpack_public_path__ + "static/media/file8.2120e31d.jpg";